import React from 'react';
import Humanize from 'humanize-plus';

export default function ({ size }) {
  const formatted = Humanize.fileSize(size);
  return <span>{formatted}</span>;
}
